const editors = new WeakMap();

function mountEditor(textarea) {
    const editor = document.createElement('openleaf-editor');
    editor.setAttribute('for', textarea.id);
    editor.setAttribute(
        'aria-label',
        textarea.labels?.[0]?.textContent.trim() || textarea.placeholder || 'Page content'
    );
    editor.setAttribute('skin', 'paper');
    editor.setAttribute('theme', 'light');
    editor.setAttribute('menubar', 'edit insert format view table');
    editor.setAttribute('toolbar-overflow', '');
    editor.setAttribute(
        'toolbar',
        'undo redo | blockType fontFamily fontSize | textColour highlightColour | bold italic | ' +
            'alignLeft alignCenter alignRight alignJustify | bulletList orderedList outdent indent | ' +
            'link image media emoji insertTable | find preview source fullscreen'
    );
    if (textarea.placeholder) editor.setAttribute('placeholder', textarea.placeholder);
    if (textarea.readOnly || textarea.disabled) editor.setAttribute('readonly', '');
    // Keep the existing named submit buttons: PHP uses them to select the save action.
    // In the custom-page panel, saving belongs to AJAX, not its enclosing settings form.
    editor.addEventListener('openleaf:save', (event) => {
        event.preventDefault();
        if (textarea.id === 'page_content') {
            document.getElementById('savePageBtn')?.click();
        } else {
            const submitter = textarea.form?.querySelector(
                '[type="submit"][name^="save"], [type="submit"][name="submit_os_button"]'
            );
            if (submitter) textarea.form.requestSubmit(submitter);
        }
    });
    textarea.before(editor);
    editors.set(textarea, editor);
    return editor;
}

export async function initHTMLEditors() {
    const textareas = [...document.querySelectorAll('textarea.html-editor')];
    if (!textareas.length) return;
    try {
        // Vite emits a hashed, on-demand chunk; storefront pages never fetch the editor.
        await import('./openleaf.js');
        for (const textarea of textareas) {
            if (textarea.isConnected && !editors.has(textarea)) mountEditor(textarea);
        }
    } catch (error) {
        console.error('Could not load the HTML editor. The textareas remain available.', error);
    }
}

export function getHTMLContent(id) {
    const textarea = document.getElementById(id);
    // The bound textarea sync is deferred; AJAX must read the current editor value.
    return editors.get(textarea)?.value ?? textarea?.value ?? '';
}

export function loadHTMLDocument(id, html) {
    const textarea = document.getElementById(id);
    if (!textarea) return;
    const editor = editors.get(textarea);
    // A new document must not inherit the previous page's undo history or source mode.
    editor?.remove();
    textarea.value = html;
    if (editor) mountEditor(textarea);
}
